import { computed, inject, Injectable } from '@angular/core';

import { UploadCapabilitiesRepository } from '@data/repositories';
import { ProccessStatus, TProccessStatusData } from '@data/types';
import { DateTimeAdapter } from '@domain/adapters';
import { FileUpload, UploadCapabilityStatus } from '@domain/entities';
import { Command } from '@domain/helpers';

@Injectable({
  providedIn: 'root',
})
export class UpdateCapabilityStatusFacade {
  private readonly uploadRepository = inject(UploadCapabilitiesRepository);

  readonly uploadStatus = new Command<UploadCapabilityStatus, void>(() =>
    this._getUploadStatus(),
  );

  readonly uploadFile = new Command((file: File) => this._uploadFile(file));

  readonly listErrors = computed(() =>
    this.uploadStatus.data()?.errors?.listErrorMap(),
  );

  readonly fileListErrors = computed(() =>
    this.uploadStatus.data()?.errors?.fileListErrors(),
  );

  readonly currentStatus = computed(
    () => this.uploadStatus.data()?.status || 'Not Loaded',
  );

  readonly lastCheckData = computed<TProccessStatusData>(() => {
    const date = this.uploadStatus.data()?.lastProcessDate;
    const status = this.uploadStatus.data()?.status;

    if (['Successful', 'Error'].includes(status)) {
      return {
        show: true,
        data: {
          lastProcessDate: DateTimeAdapter.toFullDate(date.toISOString()),
          status: ProccessStatus[status],
        },
      };
    }

    return {
      show: false,
      data: null,
    };
  });

  readonly fileError = computed(() => {
    if (this.uploadStatus.data()?.status === 'Error') {
      return new FileUpload(
        new File(['Error de carga'], 'errors.csv', { type: 'text/csv' }),
      );
    }

    return null;
  });

  readonly listExcelErrorRows = computed(() =>
    this.uploadStatus.data()?.errors?.fileListErrors(),
  );

  private async _uploadFile(file: File) {
    const result = await this.uploadRepository.uploadFile(file);

    return result;
  }

  private async _getUploadStatus() {
    const result = await this.uploadRepository.getLastUploadStatus();

    return result;
  }
}
